export default __webpack_public_path__ + "static/FritzphoneC4_07-a6a647d035792e298705f80d07ea69f9.webp";